import type { FC } from "react";
import type { InboundDocument } from "src/api/interfaces/inbound_document";

export type ValidationUserActionHandler = (
  inboundDocument: InboundDocument,
  metadata: any
) => Promise<FC>;

export enum ReferencedDocumentType {
  PO = "PO",
}

export enum OverriddenMetadataEntry {
  HeaderPurchaseOrder = "HeaderPurchaseOrder",
  LineItemPurchaseOrder = "LineItemPurchaseOrder",
  RelatedDocument = "RelatedDocument",
}

export enum ViewUserActionMetadataEntry {
  Default = "Default",
  LineItemMismatch = "LineItemMismatch",
}

export interface ReferencedDocumentOverride {
  documentType?: string;
  documentId?: string;
}

export interface DocumentDetailsOverride {
  referencedDocuments?: Array<ReferencedDocumentOverride>;
}

export interface RelatedDocumentsOverride {
  relatedDocuments?: Array<string>;
}
